import { combineReducers } from '@reduxjs/toolkit'

import { reducer as addressByPostalCode } from './addressByPostalCode'
import { reducer as addressDeliveryByPostalCode } from './addressDeliveryByPostalCode'

export default combineReducers({
  addressByPostalCode,
  addressDeliveryByPostalCode,
})
